export default [
  {
    for: 'category',
    actions: {
      create: true,
      update: true,
      read: true,
    },
  },
  {
    for: 'collection',
    actions: {
      update: true,
      read: true,
    },
    excludedProperties: ['text'],
  },
  {
    for: 'live-event',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: true,
      unlockEntity: true,
      blockEntity: true,
    },
  },
  {
    for: 'live-partner',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: true,
      unlockEntity: true,
      blockEntity: true,
    },
  },
  {
    for: 'link',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: true,
    },
  },
];
